import { UnitIdAndName } from '@/types/unit';
import { useSelectOptions } from './use-select-options';

export const useUnitSelectOptions = (units: UnitIdAndName[]) =>
  useSelectOptions<number, UnitIdAndName, 'unitName', 'id'>(
    units,
    'unitName',
    'id',
  );
